import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '@fortem-monorepo/js-utilities';
export const ViewContainer = ({ children, className, ...props }) => {
    return (_jsx("div", { className: cn('p-container-x w-full', className), ...props, children: children }));
};
